import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
 const Item2Modal = ({client, i, desvinculedClient}) => {
    let {name, mail, numDocument} = client;

    const handleDesvinculedCliente = () => {
        desvinculedClient({cliente: client});
    }

    return (
        <tr key={client._id}>
            <th scope="row">{i + 1}</th>
            <td className="text-center">{name}</td>
            <td className="text-center">{mail}</td>
            <td className="text-center">{numDocument}</td>
            <td className="text-center">
                <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip-top">Desvincular Cliente</Tooltip>}>
                    <button type="button" 
                            className="btn btn-sm btn-danger"
                            onClick={handleDesvinculedCliente}>
                        <i className="bi bi-trash"/>
                    </button>
                </OverlayTrigger>
            </td>
        </tr>
    );
}
export default Item2Modal;
